<template>
  <div class="edit-hot-area">
    <div class="edit-shop-header">
      <h3>热区图片设置</h3>
    </div>
    <div class="edit-shop-content">
      <section class="edit-hot-area-content">
        <el-form :model="content" label-width="90px" size="small">
          <el-form-item label="图片：">
            <el-row>
              <el-col :span="5">
                <SelectImgs :selectNum="1" :selectData="[content.img_url]" :idx="index" :selectFunc="imageChange"></SelectImgs>
              </el-col>
              <el-col :span="12">
                <p class="tips">上传后按图片比例自动展示，无需单独设置高度。</p>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="热区：">
            <el-button type="primary" size="small" icon="el-icon-crop" @click="openHotAreaDialog">配置热区</el-button>
            <span class="tips">已配置 {{ areas.length }} 个热区</span>
          </el-form-item>
        </el-form>

        <div class="area-list" v-if="areas.length > 0">
          <div class="area-row" v-for="(item, areaIndex) in areas" :key="areaIndex">
            <div class="area-name" @click="openAndSelectArea(areaIndex)">热区 {{ areaIndex + 1 }}</div>
            <select-link :setData="item.link" :index="areaIndex" :setFunc="setLink">
              <template slot="button">
                <el-input :value="item.link && item.link.title" size="small" placeholder="点击设置链接" suffix-icon="el-icon-arrow-right" readonly="readonly"></el-input>
              </template>
            </select-link>
            <el-button type="text" size="mini" class="delete-btn" @click="deleteArea(areaIndex)">删除</el-button>
          </div>
        </div>
      </section>
    </div>

    <el-dialog title="配置热区" :visible.sync="dialogVisible" width="860px" :append-to-body="true" class="hot-area-dialog">
      <div v-if="content.img_url" class="hot-area-editor">
        <div class="hot-area-layout">
          <div
            ref="canvasBox"
            class="hot-area-canvas"
            :style="{height: editorHeight + 'px'}"
            @mousedown="startDraw"
            @mousemove="handleMouseMove"
            @mouseup="endAction"
            @mouseleave="endAction">
            <img :src="content.img_url" class="editor-img" draggable="false" @load="setImageRatio" />
            <div
              class="area-rect"
              :class="{active: activeIndex === areaIndex}"
              v-for="(item, areaIndex) in areas"
              :key="areaIndex"
              :style="rectStyle(item)"
              @mousedown.stop="startMove($event, areaIndex)">
              {{ areaIndex + 1 }}
              <template v-if="activeIndex === areaIndex">
                <span class="resize-handle resize-nw" @mousedown.stop="startResize($event, areaIndex, 'nw')"></span>
                <span class="resize-handle resize-ne" @mousedown.stop="startResize($event, areaIndex, 'ne')"></span>
                <span class="resize-handle resize-sw" @mousedown.stop="startResize($event, areaIndex, 'sw')"></span>
                <span class="resize-handle resize-se" @mousedown.stop="startResize($event, areaIndex, 'se')"></span>
              </template>
            </div>
            <div class="area-rect drawing" v-if="drawingRect" :style="rectStyle(drawingRect)"></div>
          </div>
          <div class="hot-area-side">
            <div class="side-title">
              <span>热区列表</span>
              <span class="side-count">{{ areas.length }} 个</span>
            </div>
            <div class="side-empty" v-if="areas.length === 0">拖拽图片区域新增热区</div>
            <div class="side-list" v-else>
              <div
                class="side-row"
                :class="{active: activeIndex === areaIndex}"
                v-for="(item, areaIndex) in areas"
                :key="areaIndex"
                @click="selectArea(areaIndex)">
                <div class="side-row-head">
                  <span>热区 {{ areaIndex + 1 }}</span>
                  <el-button type="text" size="mini" @click.stop="deleteArea(areaIndex)">删除</el-button>
                </div>
                <div class="side-meta">
                  X {{ formatNum(item.x) }}%，Y {{ formatNum(item.y) }}%，宽 {{ formatNum(item.width) }}%，高 {{ formatNum(item.height) }}%
                </div>
                <select-link :setData="item.link" :index="areaIndex" :setFunc="setLink">
                  <template slot="button">
                    <el-input :value="item.link && item.link.title" size="small" placeholder="点击设置链接" suffix-icon="el-icon-arrow-right" readonly="readonly"></el-input>
                  </template>
                </select-link>
              </div>
            </div>
          </div>
        </div>
        <p class="dialog-tips">在图片上按住鼠标拖拽即可新增热区，新增后在下方列表设置链接。</p>
      </div>
      <div v-else class="empty-tip">请先上传热区图片。</div>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">完成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import SelectImgs from '../../components/SelectImgs'
  import selectLink from './select.link.vue'

  export default {
    components: {
      SelectImgs,
      selectLink
    },
    props: {
      index: {
        type: Number,
        default: 0
      },
      content: {}
    },
    data () {
      return {
        dialogVisible: false,
        drawing: false,
        actionType: '',
        startPoint: null,
        startRect: null,
        drawingRect: null,
        activeIndex: -1,
        resizeDirection: '',
        imageRatio: 0.4,
        editorWidth: 586
      }
    },
    computed: {
      areas () {
        if (!Array.isArray(this.content.areas)) {
          this.$set(this.content, 'areas', [])
        }
        return this.content.areas
      },
      editorHeight () {
        return Math.max(Math.round(this.editorWidth * this.imageRatio), 180)
      }
    },
    watch: {
      content: {
        handler () {
          this.contentChange()
        },
        deep: true
      },
      dialogVisible (visible) {
        if (visible) {
          this.$nextTick(this.updateEditorWidth)
        }
      }
    },
    created () {
      this.normalizeContent()
    },
    mounted () {
      window.addEventListener('resize', this.updateEditorWidth)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.updateEditorWidth)
    },
    methods: {
      normalizeContent () {
        if (!this.content.img_url) {
          this.$set(this.content, 'img_url', '')
        }
        if (!Array.isArray(this.content.areas)) {
          this.$set(this.content, 'areas', [])
        }
      },
      imageChange (val) {
        this.content.img_url = val.pic
      },
      setImageRatio (event) {
        var image = event.target
        if (image && image.naturalWidth > 0 && image.naturalHeight > 0) {
          this.imageRatio = image.naturalHeight / image.naturalWidth
          this.$nextTick(this.updateEditorWidth)
        }
      },
      updateEditorWidth () {
        if (this.$refs.canvasBox && this.$refs.canvasBox.clientWidth > 0) {
          this.editorWidth = this.$refs.canvasBox.clientWidth
        }
      },
      openHotAreaDialog () {
        if (!this.content.img_url) {
          this.$message.warning('请先上传图片')
          return
        }
        this.dialogVisible = true
      },
      openAndSelectArea (areaIndex) {
        if (!this.content.img_url) {
          this.$message.warning('请先上传图片')
          return
        }
        this.activeIndex = areaIndex
        this.dialogVisible = true
      },
      contentChange () {
        this.$emit('message', this.content)
      },
      pointFromEvent (event) {
        var rect = this.$refs.canvasBox.getBoundingClientRect()
        var x = Math.min(Math.max(event.clientX - rect.left, 0), rect.width)
        var y = Math.min(Math.max(event.clientY - rect.top, 0), rect.height)
        return {
          x: x / rect.width * 100,
          y: y / rect.height * 100
        }
      },
      startDraw (event) {
        if (event.target !== this.$refs.canvasBox && event.target.tagName !== 'IMG') {
          return
        }
        this.drawing = true
        this.actionType = 'draw'
        this.startPoint = this.pointFromEvent(event)
        this.drawingRect = {
          x: this.startPoint.x,
          y: this.startPoint.y,
          width: 0,
          height: 0
        }
      },
      startMove (event, areaIndex) {
        this.activeIndex = areaIndex
        this.actionType = 'move'
        this.startPoint = this.pointFromEvent(event)
        this.startRect = this.copyRect(this.areas[areaIndex])
      },
      startResize (event, areaIndex, direction) {
        this.activeIndex = areaIndex
        this.actionType = 'resize'
        this.resizeDirection = direction
        this.startPoint = this.pointFromEvent(event)
        this.startRect = this.copyRect(this.areas[areaIndex])
      },
      handleMouseMove (event) {
        if (!this.actionType || !this.startPoint) {
          return
        }
        var current = this.pointFromEvent(event)
        if (this.actionType === 'draw') {
          this.drawingRect = {
            x: Math.min(this.startPoint.x, current.x),
            y: Math.min(this.startPoint.y, current.y),
            width: Math.abs(current.x - this.startPoint.x),
            height: Math.abs(current.y - this.startPoint.y)
          }
          return
        }
        if (this.actionType === 'move') {
          this.moveActiveArea(current)
          return
        }
        if (this.actionType === 'resize') {
          this.resizeActiveArea(current)
        }
      },
      endAction () {
        if (!this.actionType) {
          return
        }
        if (this.actionType === 'draw' && this.drawingRect && this.drawingRect.width > 2 && this.drawingRect.height > 2) {
          this.areas.push(Object.assign({}, this.drawingRect, {
            link: {}
          }))
          this.activeIndex = this.areas.length - 1
        }
        this.drawing = false
        this.actionType = ''
        this.startPoint = null
        this.startRect = null
        this.drawingRect = null
        this.resizeDirection = ''
      },
      moveActiveArea (current) {
        if (this.activeIndex < 0 || !this.startRect) {
          return
        }
        var dx = current.x - this.startPoint.x
        var dy = current.y - this.startPoint.y
        var next = Object.assign({}, this.areas[this.activeIndex], {
          x: this.clamp(this.startRect.x + dx, 0, 100 - this.startRect.width),
          y: this.clamp(this.startRect.y + dy, 0, 100 - this.startRect.height),
          width: this.startRect.width,
          height: this.startRect.height
        })
        this.$set(this.areas, this.activeIndex, next)
      },
      resizeActiveArea (current) {
        if (this.activeIndex < 0 || !this.startRect) {
          return
        }
        var minSize = 2
        var dx = current.x - this.startPoint.x
        var dy = current.y - this.startPoint.y
        var left = this.startRect.x
        var top = this.startRect.y
        var right = this.startRect.x + this.startRect.width
        var bottom = this.startRect.y + this.startRect.height
        if (this.resizeDirection.indexOf('w') !== -1) {
          left = this.clamp(left + dx, 0, right - minSize)
        }
        if (this.resizeDirection.indexOf('e') !== -1) {
          right = this.clamp(right + dx, left + minSize, 100)
        }
        if (this.resizeDirection.indexOf('n') !== -1) {
          top = this.clamp(top + dy, 0, bottom - minSize)
        }
        if (this.resizeDirection.indexOf('s') !== -1) {
          bottom = this.clamp(bottom + dy, top + minSize, 100)
        }
        var next = Object.assign({}, this.areas[this.activeIndex], {
          x: left,
          y: top,
          width: right - left,
          height: bottom - top
        })
        this.$set(this.areas, this.activeIndex, next)
      },
      copyRect (item) {
        return {
          x: Number(item.x || 0),
          y: Number(item.y || 0),
          width: Number(item.width || 0),
          height: Number(item.height || 0)
        }
      },
      clamp (value, min, max) {
        return Math.min(Math.max(value, min), max)
      },
      rectStyle (item) {
        return {
          left: (item.x || 0) + '%',
          top: (item.y || 0) + '%',
          width: (item.width || 0) + '%',
          height: (item.height || 0) + '%'
        }
      },
      setLink (item, areaIndex) {
        this.$set(this.areas[areaIndex], 'link', item)
      },
      selectArea (areaIndex) {
        this.activeIndex = areaIndex
      },
      formatNum (value) {
        return Number(value || 0).toFixed(1)
      },
      deleteArea (areaIndex) {
        this.areas.splice(areaIndex, 1)
        if (this.areas.length === 0) {
          this.activeIndex = -1
        } else if (this.activeIndex >= this.areas.length) {
          this.activeIndex = this.areas.length - 1
        }
      }
    }
  }
</script>

<style scoped>
  .edit-hot-area-content {
    padding: 0 10px;
  }
  .tips {
    color: #999;
    margin-left: 10px;
  }
  .area-list {
    padding: 0 10px 10px;
  }
  .area-row {
    display: flex;
    align-items: center;
    background-color: #f8f8f9;
    margin-bottom: 10px;
    padding: 10px;
  }
  .area-name {
    width: 70px;
    color: #333;
    cursor: pointer;
  }
  .area-name:hover {
    color: #409EFF;
  }
  .area-row .select-links {
    flex: 1;
  }
  .delete-btn {
    margin-left: 10px;
  }
  .hot-area-editor {
    user-select: none;
  }
  .hot-area-layout {
    display: flex;
    align-items: flex-start;
  }
  .hot-area-canvas {
    position: relative;
    flex: 1;
    min-width: 0;
    margin: 0 auto;
    overflow: hidden;
    background-color: #f5f5f5;
    cursor: crosshair;
  }
  .editor-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: fill;
    pointer-events: none;
  }
  .area-rect {
    position: absolute;
    box-sizing: border-box;
    border: 2px solid #ff4d4f;
    background-color: rgba(255, 77, 79, 0.18);
    color: #fff;
    text-align: center;
    line-height: 22px;
    cursor: move;
  }
  .area-rect.active {
    border-color: #409EFF;
    background-color: rgba(64, 158, 255, 0.2);
  }
  .area-rect.drawing {
    pointer-events: none;
  }
  .resize-handle {
    position: absolute;
    width: 8px;
    height: 8px;
    border: 1px solid #409EFF;
    background-color: #fff;
    box-sizing: border-box;
  }
  .resize-nw {
    left: -5px;
    top: -5px;
    cursor: nwse-resize;
  }
  .resize-ne {
    right: -5px;
    top: -5px;
    cursor: nesw-resize;
  }
  .resize-sw {
    left: -5px;
    bottom: -5px;
    cursor: nesw-resize;
  }
  .resize-se {
    right: -5px;
    bottom: -5px;
    cursor: nwse-resize;
  }
  .hot-area-side {
    width: 260px;
    margin-left: 14px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background-color: #fff;
  }
  .side-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 38px;
    padding: 0 12px;
    border-bottom: 1px solid #ebeef5;
    font-weight: 600;
  }
  .side-count {
    color: #999;
    font-weight: 400;
  }
  .side-empty {
    padding: 24px 12px;
    color: #999;
    text-align: center;
  }
  .side-list {
    max-height: 560px;
    overflow-y: auto;
    padding: 10px;
  }
  .side-row {
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    cursor: pointer;
  }
  .side-row.active {
    border-color: #409EFF;
    background-color: #ecf5ff;
  }
  .side-row-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
  }
  .side-meta {
    margin-bottom: 8px;
    color: #999;
    font-size: 12px;
    line-height: 18px;
  }
  .dialog-tips,
  .empty-tip {
    color: #999;
    margin-top: 10px;
    text-align: center;
  }
</style>
